export default function routes(app, done) {
  app.routes = {
    /**
     * For standalone journey planner
     */
    '/': routeResolver(import('../js'), 'JourneyPlannerPage'),
    '/fare_calculator': routeResolver(import('../js'), 'FareCalculatorPage'),
  };

  function routeResolver(pages, page) {
    return {
      onmatch: async (args, requestedPath, route) => {
        console.log('match: ', args, requestedPath, route);
        const p = await Promise.resolve(pages);
        const component = page ? p[page] : p;
        if (!component) {
          console.error("RouteResolver: component not found for page: ", page);
          return {
            view: () => m("div", "Component not found")
          };
        }
        return component;
      },
      render: vnode => vnode
    };
  }

  done();
}
